import { render, staticRenderFns } from "./msgTitle.vue?vue&type=template&id=358c86c4&scoped=true&"
import script from "./msgTitle.vue?vue&type=script&lang=js&"
export * from "./msgTitle.vue?vue&type=script&lang=js&"
import style0 from "./msgTitle.vue?vue&type=style&index=0&id=358c86c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358c86c4",
  null
  
)

export default component.exports